// extracted by mini-css-extract-plugin
export default {"label":"TextEditor_label__nyfyA"};